import { BLOG_EMPTY_FILTER_MESSAGE } from '@/features/blog/constants/blog.constants'
import { BlogPostCard } from '@/features/blog/components/blog-post-card'
import { BlogPagination } from '@/features/blog/components/blog-pagination'
import type { BlogPost } from '@/features/blog/types/blog.types'

export function BlogPostsSection({
  posts,
  serifHeadingClass,
  isEmpty,
  currentPage,
  totalPages,
  onPageChange,
}: {
  posts: BlogPost[]
  serifHeadingClass: string
  isEmpty: boolean
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}) {
  return (
    <>
      {/* `post.slug` is a stable React key across filter/pagination churn. */}
      <ul className="mt-10 grid list-none grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-12 lg:grid-cols-3">
        {posts.map((post) => (
          <li key={post.slug}>
            <BlogPostCard post={post} serifHeadingClass={serifHeadingClass} />
          </li>
        ))}
      </ul>

      {isEmpty ? (
        <p className="mt-16 text-center text-sm text-neutral-600">{BLOG_EMPTY_FILTER_MESSAGE}</p>
      ) : null}

      <BlogPagination
        className="mt-12 lg:mt-14"
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </>
  )
}
